import ReactDOM from "react-dom";

import { CalendarStore } from "@/Appointments/Stores/CalendarStore";
import { PAListStore } from "@/Appointments/Stores/PAListStore";
import { ApiSettings } from "@/Common/Api/ApiSettings";
import { Client } from "@/Common/Api/Client";
import { realTimeNotificationClient } from "@/Common/Api/RealTimeNotification/SignalRClient";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { OverlayStore } from "@/Common/Stores/OverlayStore";
import { RamqStore } from "@/Common/Stores/RamqStore";
import { CacheStore } from "@/Globals/Stores/CacheStore";
import { SessionStore } from "@/Globals/Stores/SessionStore";
import { PatientStore } from "@/Patient/Stores/PatientStore";
import { SettingsStore } from "@/Settings/Stores/SettingsStore";
import { PAList } from "../EntryPoints/PAListApp/PAList";

export class PAListApp {
    private timer = null;

    public async Start(
        rootpathArg: string,
        elementID: string,
        parentCacheStore: CacheStore,
        parentSessionStore: SessionStore,
        parentCalendarStore: CalendarStore,
        parentApiSetting: ApiSettings,
        parentSettingStore: SettingsStore,
        parentPatientStore: PatientStore
    ): Promise<void> {
        if (rootpathArg && rootpathArg.length > 0) {
            window.rootPath = rootpathArg;
            window.baseURI = baseURI + rootPath;
        }

        window.apiSettings = parentApiSetting;
        window.cacheStore = CacheStore.createSingletonFrom(parentCacheStore, false);
        window.sessionStore = SessionStore.createSingletonFrom(parentSessionStore);

        if (!sessionStore.isAuthenticated())
            window.close();

        window.calendarStore = CalendarStore.createSingletonFrom(parentCalendarStore);
        window.settingsStore = SettingsStore.createSingletonFrom(parentSettingStore);
        window.patientStore = PatientStore.createSingletonFrom(parentPatientStore, false);
        window.ramqStore = RamqStore.createSingleton();
        window.overlayStore = OverlayStore.createSingleton();

        if (cacheStore.ClinicSettings.EnableRealTimeNotifications)
            return await this.setupRealTimeNotifications(elementID);

        this.instantiatePAList(elementID);
    }

    private instantiatePAList(elementID: string): void {
        window.paListStore = PAListStore.createSingleton();
        this.resetUserSettingsCache();
        this.renderPAList(elementID);
    }

    private async setupRealTimeNotifications(elementID: string): Promise<void> {
        window.onclose = () => {
            realTimeNotificationClient.disconnect();
        };

        await realTimeNotificationClient.connect();

        this.instantiatePAList(elementID);
    }

    private renderPAList(elementID: string): void {
        ReactDOM.render(<PAList />, document.getElementById(elementID));
        $(window).resize(this.computeResize);
    }

    private resetUserSettingsCache(): void {
        const client = new Client();
        client.Post(
            ServerOperations.Server.Myle_LoadUserSettings,
            {},
            data => cacheStore.UserSettings = data.UserSettings,
            () => { /* on error callback */ }
        );
    }

    private computeResize(): void {
        clearTimeout(this.timer);

        this.timer = setTimeout(
            () => {
                var elem = $("#posref");
                var fxdHeightElement = $(".fxheight");

                var footer = $(".ws-footer");
                var footerHeight = footer.length === 0 ? 0 : footer.outerHeight();
                var headerHeight = $(".myle-page-header").outerHeight();
                var winHeight = $(window).outerHeight() - headerHeight - 51; // -50

                if (elem.length) {
                    var maxScroll = (winHeight - footerHeight); // headerHeight
                    $(".ws-scrollable").css("max-height", maxScroll + "px");
                    $(".ws-scrollable").css("min-height", maxScroll + "px");
                }

                fxdHeightElement.each(function() {
                    var fxd = $(this);
                    var hvar = +fxd.attr("data-hvar");
                    if (isNaN(hvar))
                        hvar = 0;
                    var maxScroll = (winHeight - footerHeight) + hvar; // headerHeight
                    fxd.css("height", maxScroll + "px");
                    var scrollableElements = fxd.find(".scrollable");
                    scrollableElements.each(function() {
                        var elem = $(this);
                        var hvar = +elem.attr("data-hvar");
                        if (isNaN(hvar))
                            hvar = 0;
                        var displacement = elem.position().top - fxd.position().top;
                        if (isNaN(displacement))
                            displacement = 0;
                        if (displacement < 0)
                            displacement = 0;
                        elem.css("max-height", (maxScroll - displacement - hvar) + "px");
                        elem.css("min-height", (maxScroll - displacement - hvar) + "px");
                    });
                    fxd.find(".fixed").each(function() {
                        var elem = $(this);
                        elem.css("height", maxScroll + "px");
                    });
                    fxd.find(".withverticalscroll").each(function() {
                        var elem = $(this);
                        elem.css("overflow-y", "auto");
                    });
                });
            },
            10
        );
    }
}
